/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Openai_DescriptionInputs */

const en_admin_settings_groups_openai_description = /** @type {(inputs: Admin_Settings_Groups_Openai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI (or compatible) API`)
};

const zh_admin_settings_groups_openai_description = /** @type {(inputs: Admin_Settings_Groups_Openai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI（或兼容）API`)
};

/**
* | output |
* | --- |
* | "OpenAI (or compatible) API" |
*
* @param {Admin_Settings_Groups_Openai_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_openai_description = /** @type {((inputs?: Admin_Settings_Groups_Openai_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Openai_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_openai_description(inputs)
	return zh_admin_settings_groups_openai_description(inputs)
});
export { admin_settings_groups_openai_description as "admin.settings.groups.openai.description" }